/* istanbul ignore file */
import React from 'react';
import { DropDownFilter } from 'framework/list';
import AssetCategoryDropdown from 'domain/finance/assets/shared/input/AssetCategoryDropdown';

const AssetCategoryDropdownFilter = (props: any) => {
  return (
    <DropDownFilter {...props}>
      <AssetCategoryDropdown {...props} />
    </DropDownFilter>
  );
};

export default AssetCategoryDropdownFilter;
